import { V3PrivacySubContractors } from "../../pagelayouts/privacy/subcontractors";

const Subcontractors = () => {
    return <V3PrivacySubContractors />
}

export default Subcontractors;